import { ApplicationRef, Injectable } from '@angular/core';
import { defer, Observable, Subject } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../configuration/configuration-service';

@Injectable({
	providedIn: 'root'
})
export class TranslateService {

	public traduzioniLib$ = new Observable<Map<string, string>>();
	public communicatoreConEsterno$ = new Subject<any>();
	loadingLinguage: boolean;
	i18nApiUrl;

	constructor(private http: HttpClient,
		private appRef: ApplicationRef,
		private configurationService: ConfigurationService) {

		this.i18nApiUrl = this.configurationService.servicePaths.get("I18N_MS_API_URL");
		console.log('[DAG_I18N_MS_URL]', this.i18nApiUrl);

		this.traduzioniLib$ = this.configurationService.lingua$.pipe(
			switchMap(language => this.getBundleTraduzioni$(language)),
			tap(_ => setTimeout(() => this.appRef.tick(), 0)),
			shareReplay()
		);
	}

	getTraduzione$(codice: string): Observable<string> {
		return defer(() => this.traduzioniLib$.pipe(
			map(bundle =>
				bundle.get(codice) || codice
			)
		));
	}

	private getBundleTraduzioni$(language): Observable<Map<string, string>> {
		const url: string = this.i18nApiUrl + '/v1/labels/' + this.configurationService.nameApp + '/' + language;
		return this.http.get(url).pipe(
			map(this.reduceLabels),
			tap(_ => this.communicatoreConEsterno$.next(true))
		);
	}

	private reduceLabels(labels: Array<any>): Map<string, string> {
		const reduced = labels.reduce((acc: Map<string, string>, label) => {
			return acc.set(label["codiceLabel"], label["label"])
		},
			new Map<string, string>());

		return reduced;
	}

}
